export default "__VITE_ASSET__CtUEmpFp__"